import { connect } from "react-redux";

import { RootState } from "store/store";

import { setModalLoaderVisibility } from "store/common/modal-window/modal-window-slices";
import { setErrorResponseMessage } from "store/common/initialization/initialization-actions";

import {
    getPartnerId,
    getIsHistoryOpened,
} from "store/partners/partners-selectors";
import { setIsPartnerHistoryOpened } from "store/partners/partners-actions";

import PartnerHistory from "./PartnerHistory";

const mapStateToProps = (state: RootState) => ({
    isOpened: getIsHistoryOpened(state),
    partnerId: getPartnerId(state),
});

const PartnerHistoryContainer = connect(mapStateToProps, {
    setModalLoaderVisibility,
    setErrorResponseMessage,
    setIsPartnerHistoryOpened,
})(PartnerHistory);

export default PartnerHistoryContainer;
